import { useEffect } from "react";
import { useCacheBuster } from "react-cache-buster";

const POLL_INTERVAL_MS = 5 * 60 * 1000;

const AppVersionChecker = () => {
  const { checkCacheStatus } = useCacheBuster();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    const check = () => {
      checkCacheStatus();
    };

    const intervalId = window.setInterval(check, POLL_INTERVAL_MS);
    window.addEventListener("focus", check);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", check);
    };
  }, [checkCacheStatus]);

  return null;
};

export default AppVersionChecker;
